import { render, staticRenderFns } from "./budget-unsaved-changes-modal.vue?vue&type=template&id=2146fa8f&"
import script from "./budget-unsaved-changes-modal.vue?vue&type=script&lang=ts&"
export * from "./budget-unsaved-changes-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports